module.exports = __webpack_public_path__ + "static/img/8.ec89a84.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/15/zh/8.png
// module id = B8vy
// module chunks = 0